import {TableCell, TableRow} from "@material-ui/core";
import _ from "lodash";
import React from "react";
import {makeStyles} from "@material-ui/styles";
import {formatDateUS} from "../../../../helpers/utils";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  inheritFontWeight: {
    fontWeight: 'inherit',
  }
}));


const keys = [
  { id: 'currently_employed_company_crd_id', name: 'currently_employed_company_crd_id' },
  { id: 'currently_employed_company_name', name: 'currently_employed_company_name' },
  { id: 'currently_employed_company_hq_city', name: 'currently_employed_company_hq_city' },
  { id: 'currently_employed_company_hq_country', name: 'currently_employed_company_hq_country' },
  { id: 'currently_employed_company_state', name: 'currently_employed_company_state' },
  { id: 'currently_employed_company_street_1', name: 'currently_employed_company_street_1' },
  { id: 'currently_employed_company_street_2', name: 'currently_employed_company_street_2' },
  { id: 'currently_employed_company_postal', name: 'currently_employed_company_postal' },
]

const CurrentlyEmployedRow = (props) => {
  const {currentCompanies} = props;
  const classes = useStyles();

  return (
    currentCompanies.map(((currentCompany, index) =>
        <TableRow hover key={`row-history-${index}`}>
          {keys.map(((key) =>
            <TableCell key={`${key.name}-row-history-data-${index}`} className={classes.inheritFontWeight}>
              {_.isNil(currentCompany.attributes[key.id]) ? '' : `${currentCompany.attributes[key.id]}`}
            </TableCell>
          ))}
          <TableCell className={classes.inheritFontWeight}>
            {
              moment(currentCompany.attributes.current_employment_start_date, "YYYY-MM-DD").format('MM/DD/YYYY')
            }
          </TableCell>
        </TableRow>
    ))
  )
}

export default CurrentlyEmployedRow;